// extracted by mini-css-extract-plugin
module.exports = {"truncate":"TruncateText_truncate__qztIG","truncate-readmore":"TruncateText_truncate-readmore__QTMIw"};